import React from 'react';
import { Avatar, Typography, Box, capitalize } from '@mui/material';
import fotoPerfil from '../../assets/images/admin.jpg';
import { AuthContext } from '../../contexto';
import { toTitleCase } from '../../utilidades/capitalize';
import useAuthContext from '../../modules/auth/hook/useAuthContext';

interface UserProfileHeaderProps {
  isCollapsed: boolean;
}

const UserProfileHeader = ({ isCollapsed }: UserProfileHeaderProps) => {
  const { user } = useAuthContext();

  // Si no hay usuario logueado, no renderizamos nada
  if (!user) return null;

  const userInitial = (user?.nombre || '').charAt(0).toUpperCase();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2,
        py: isCollapsed ? 1 : 2.5,
        width: '100%',
        transition: 'all 0.2s ease-in-out',
        overflow: 'hidden',
      }}
    >
      {/* Avatar Cuadrado Redondeado con Sombra Suave */}
      <Avatar
        alt={user?.nombre}
        src={fotoPerfil}
        variant="rounded" // Esto le da la forma cuadrada de Cliniva
        sx={{
          width: isCollapsed ? 42 : 80,
          height: isCollapsed ? 42 : 80,
          borderRadius: '18px', // Bordes redondeados idénticos a la imagen
          backgroundColor: 'primary.main',
          fontWeight: 750,
          fontSize: isCollapsed ? 16 : 28,
          boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.06)', // Sombra limpia difuminada
          transition: 'all 0.2s ease-in-out',
          '& img': {
            objectFit: 'cover',
          }
        }}
      >
        {userInitial}
      </Avatar>

      {/* Datos del usuario (Se ocultan elegantemente si el menú se colapsa) */}
      {!isCollapsed && (
        <Box sx={{ mt: 1.5, width: '100%', minWidth: 0 }}>
          <Typography
            noWrap
            sx={{
              fontSize: '14.5px',
              fontWeight: 500,
              color: '#1a1c1e',
              lineHeight: 1.3,
            }}
          >
            {toTitleCase(user?.nombre)}
          </Typography>
          <Typography
            noWrap
            sx={{
              fontSize: '11px',
              color: '#8a92a6',
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              mt: 0.2,
            }}
          >
            {toTitleCase(user?.rol)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default UserProfileHeader;